import React from 'react';
import { Carousel, CarouselBody, CarouselSlider, CarouselSliderItem } from '@lux/carousel';
import { getCampaignImage } from '@browsing/campaign';
import { trackSelectPromotion } from '@browsing/tracking';
import { ErrorBoundary } from '@browsing/components';

import { Campaign } from '@shared/types/mylounge';

import { CampaignCardMini } from '../campaigns/components/campaign-card-mini';
import AllCampaignsCard from '../campaigns/components/all-campaigns-card';

interface GRECarouselProps {
    campaigns: Campaign[];
}

const GRECarousel = ({ campaigns }: GRECarouselProps) => {
    // Filter out any undefined campaigns
    const validCampaigns = campaigns.filter(Boolean);

    return (
        <Carousel className="mb-sm" data-testid="gre-carousel">
            <CarouselBody
                aria-labelledby="gre-carousel-title"
                visibleItems={2}
                visibleItemsSm={4}
                visibleItemsLg={6}
            >
                <CarouselSlider>
                    {validCampaigns.map((campaign, index) => {
                        const handleCampaignClick = () => {
                            trackSelectPromotion({
                                element: 'gre_carousel',
                                creativeName: 'gre_carousel',
                                item: { campaignIdentifier: campaign.campaignId },
                            });
                        };

                        if (index === validCampaigns.length - 1) {
                            const media = getCampaignImage(campaign, '1x2');

                            return (
                                <ErrorBoundary
                                    componentName={`GRECarouselAllCampaignsCard-${campaign.campaignId}`}
                                >
                                    <CarouselSliderItem key={campaign.campaignId}>
                                        <AllCampaignsCard imageUrl={media.url} />
                                    </CarouselSliderItem>
                                </ErrorBoundary>
                            );
                        }

                        const media = getCampaignImage(campaign, '1x1');

                        return (
                            <ErrorBoundary
                                componentName={`GRECarouselCampaignCard-${campaign.campaignId}`}
                            >
                                <CarouselSliderItem key={campaign.campaignId}>
                                    <CampaignCardMini
                                        campaign={campaign}
                                        media={media}
                                        bgTransparent
                                        hideTimeLeft
                                        onClick={handleCampaignClick}
                                    />
                                </CarouselSliderItem>
                            </ErrorBoundary>
                        );
                    })}
                </CarouselSlider>
            </CarouselBody>
        </Carousel>
    );
};

export default GRECarousel;
